import React from 'react';
import './LoginForm.css'
import { Layout, Row, Col, Form, Input, Button, message } from 'antd';
import { Link } from "react-router-dom"
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { store } from './store';
import * as authService from './authService';

const { Content } = Layout;

const LoginForm = (props) => {

  const onFinish = async (loginInfo) => {
    try {
      // 1. Authenticate via backend (BFF)
      const tokens = await authService.login(loginInfo.username, loginInfo.password);

      // 2. Set axios auth header
      axios.defaults.headers.common['Authorization'] = `Bearer ${tokens.id_token}`;

      // 3. Get session info from backend
      const sessionRes = await axios.post('/auth/session');
      const session = sessionRes.data;

      // 4. Check role before granting access
      if (session.role === 'prestudent' || session.role === 'preprofessor') {
        message.warning('교육실의 가입인증 후 사용 가능합니다.');
        delete axios.defaults.headers.common['Authorization'];
        return;
      }

      // 5. Store in Redux and navigate
      store.dispatch({
        type: 'SET_COGNITO_TOKENS',
        idToken: tokens.id_token,
        refreshToken: tokens.refresh_token,
      });
      store.dispatch({ type: 'SET_SESSION', session: session });
      window.location.href = '/';

    } catch (err) {
      console.error('Login error:', err);

      const code = err.response?.data?.code;
      if (code === 'PROFILE_NOT_FOUND') {
        window.location.href = '/sign_up?complete_profile=true';
        return;
      }
      if (code === 'UserNotConfirmedException') {
        message.warning('이메일 인증이 필요합니다');
        if (props.history) {
          props.history.push('/verify_email?email=' + encodeURIComponent(loginInfo.username));
        } else {
          window.location.href = '/verify_email?email=' + encodeURIComponent(loginInfo.username);
        }
        return;
      }

      const msg = err.response?.data?.message || err.message || '로그인에 실패했습니다';
      message.warning(msg);
    }
  };

  return (
    <Layout style={{
      minHeight: '100vh',
      padding: '25px',
    }}>
      <Content>
        <div className="site-layout-background" >
          <Row >
            <Col span={8} offset={8}>
              <div style={{
                backgroundImage: 'url("/eportfolio_logo.png")',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                marginTop: '50px',
                marginBottom: '100px',
                width: '100%',
                height: '300px'
              }}>
              </div>
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please input your Username!' }]}
                >
                  <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="이메일 (@snu.ac.kr)" />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input your Password!' }]}
                >
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="비밀번호"
                  />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    로그인
                  </Button>
                </Form.Item>
                <Link to='/sign_up'><Button type='dashed' htmlType='button' className="login-form-button">
                  학생 회원가입
                </Button></Link>
                <Link to='/sign_up_professor'><Button type='dashed' htmlType='button' className="login-form-button" style={{ marginTop: '8px' }}>
                  교수 회원가입
                </Button></Link>
                <div style={{ marginTop: '10px', textAlign: 'center' }}>
                  <Link to='/forgot_password'>비밀번호 찾기</Link>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default LoginForm
